<template>
	<v-dialog
		class="dialog"
		v-model="visible"
		max-width="400"
		persistent
	>
		<v-alert
			class="mb-0"
			border="top"
			colored-border
			color="info"
		>
			<div class="main-content">
				<div>
					<div class="title-text">Unsaved changes</div>
					<div class="content-text">Do you want to save changes before leaving this screen?</div>
				</div>
			</div>
			<div class="button mt-4">
				<v-btn class="text-capitalize" outlined color="rgba(25, 42, 62, 0.7)" @click="$emit('cancel')">
					Cancel
				</v-btn>
				<v-btn depressed color="info" class="ml-2 white--text text-capitalize" @click="$emit('ok')">
					<v-icon left>
						mdi-check
					</v-icon>
					Yes, save
				</v-btn>
			</div>
		</v-alert>
	</v-dialog>
</template>
<script>
export default {
	name: 'UnsavedConfirmDialog',
	props:{
		visible: {
			type: Boolean,
			default: false
		},
	}
}
</script>
<style lang="scss" scoped>
.dialog {
	padding: 20px;
}
.main-content {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
}
.title-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #192A3E;
}
.content-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
}
.button {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
}
</style>